<template>

    <div class="hero is-primary">
      <div class="hero-body">
          <h1 class="title is-spaced has-text-centered is-uppercase">
            Jeg vil
          </h1>
        <h1 class="title is-spaced has-text-centered is-uppercase">
          <p class="subtitle has-text-centered">
          <router-link
          style="margin-right:1.5rem !important;"
            class="button is-primary is-inverted is-outlined is-medium"
            :to="{ name: 'customers.register' }"
          >
            Være kunde hos Taskflex
          </router-link>
          <router-link
          style="margin-left:1.5rem !important;"
            class="button is-primary is-inverted is-outlined is-medium"
            :to="{name: 'new-student'}"
          >
            Være student freelancer
          </router-link>
        </p>
        </h1>
      </div>
    </div>

</template>

<script>
export default {
  name: 'RegisterCard'
}
</script>



// WEBPACK FOOTER //
// src/global/components/RegisterCard.vue